import bowser from 'bowser';

export default () => {
  const obj = bowser.getParser(window.navigator.userAgent);
  obj.isInWechat = !!(
    navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0
  );
  obj.isInMixin = !!(
    (window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.MixinContext) ||
    window.MixinContext
  );
  obj.isInIos = obj.parsedResult.os.name === 'iOS';
  obj.isInAndroid = obj.parsedResult.os.name === 'Android';
  return obj;
};
